import Configuration from "../config.js";

let loggedGroupFallback = false;

function getHeaders() {
    try {
        const userDataRaw = sessionStorage.getItem("user");
        const token = sessionStorage.getItem("token");
        if (!userDataRaw || !token) return {};
        const parsedUser = JSON.parse(userDataRaw);
        return {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "x-tenant": parsedUser?.destine || "",
        };
    } catch {
        return {};
    }
}

export async function fetchAdminClients(userId) {
    if (!userId) return [];
    try {
        const conf = Configuration.getConfiguration();
        const response = await fetch(
            `${conf.ADMI_BO}/credentials?prefix=am_clients.${userId}`,
            { headers: getHeaders() }
        );
        const map = await response.json();
        const key = `am_clients.${userId}`;
        const raw = map[key];
        if (raw) {
            return raw.split(",").map(v => v.trim()).filter(Boolean);
        }
    } catch (e) {
        console.warn(`[credentialsApi] Error fetching am_clients for user ${userId}`, e);
    }
    return [];
}

export async function getClientFilterCodes() {
    let data = {};
    try { data = JSON.parse(sessionStorage.getItem("user") || "{}"); } catch {}
    const role = Number(data?.rol ?? data?.role ?? null);
    if (role === -1) return null;
    const groupCode = data?.client_code ?? data?.clientCode ?? null;
    const clientsArray = Array.isArray(data?.clients) ? data.clients : [];
    if (role === 10) {
        const userId = data?.id;
        if (userId) {
            const codes = await fetchAdminClients(userId);
            if (codes.length) return codes;
        }
    }
    if (groupCode) return await fetchGroupClients(groupCode);
    if (clientsArray.length) return clientsArray.map(c => c.code).filter(Boolean);
    return [];
}

export async function fetchGroupClients(groupCode) {
    if (!groupCode) return [];
    try {
        const conf = Configuration.getConfiguration();
        const response = await fetch(
            `${conf.ADMI_BO}/credentials?prefix=client_group.${groupCode}`,
            { headers: getHeaders() }
        );
        const map = await response.json();
        const key = `client_group.${groupCode}`;
        const raw = map[key];
        if (raw) {
            const clients = raw.split(",").map(v => v.trim()).filter(Boolean);
            if (!loggedGroupFallback) {
                console.log(`[credentialsApi] Groups loaded from backend: ${groupCode} →`, clients);
                loggedGroupFallback = true;
            }
            return clients;
        }
    } catch (e) {
        console.warn(`[credentialsApi] Error fetching group "${groupCode}" from backend`, e);
    }
    return [groupCode];
}
